import { Card } from "antd"
import Chart from "react-apexcharts"
import { Purify } from "@shared/components"
import React from "react"

interface IFProps {
	labels?: string[]
	count?: number[]
	loading?: boolean
}
const OperatorChart: React.FC<IFProps> = ({ labels, count, loading }) => {
	return (
		<Card title="Operator Wise" style={{ minHeight: 300 }}>
			<Purify
				loading={loading}
				empty={labels?.length === 0 || count?.length === 0}>
				<div style={{ justifyContent: "center", display: "flex" }}>
					<Chart
						options={
							{
								chart: {
									width: 280,
									height: 280,
									type: "pie",
									labels: {
										itemMargin: {
											horizontal: 5,
											vertical: 0,
										},
									},
								},
								legend: {
									position: "bottom",
								},
								labels: labels,

								colors: ["#0089ff", "#F73164", "#51BB25", "#A927F9", "#DC3545"],
							} as any
						}
						series={count}
						type="pie"
						width={300}
					/>
				</div>
			</Purify>
		</Card>
	)
}

export default OperatorChart
